import React from "react";
import { Button, Dropdown } from "@gw/web-basic-components";
import { cn } from "../utils";
import { ColorSelector, IColorSelectorProps } from "color-selector-react";

interface ColorPickerProps
  extends Omit<IColorSelectorProps, "color" | "onChange"> {
  value?: string;
  onChange?: (color: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange,
  className,
  ...rest
}: ColorPickerProps) => {
  return (
    <Dropdown
      dropdownRender={() => (
        <ColorSelector
          color={value}
          onChange={(e) => onChange(e.color)}
          className={cn("wbuc-bg-[#FFFFFF]", className)}
          {...rest}
        />
      )}
      trigger={["click"]}
    >
      <Button
        className="!wbuc-visible !wbuc-w-full !wbuc-border !wbuc-border-solid !wbuc-border-[var(--wbc-text-insufficient-rgba)] [box-shadow:none]"
        style={{
          background: `${value ?? "#FFFFFF"}`,
        }}
      />
    </Dropdown>
  );
};

export default ColorPicker;
